import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Container, Segment } from 'semantic-ui-react';
import './Footer.scss';

const Footer = ({ token }) => {
  return (
    <footer className="site-footer">
      <Container>
        <div className="site-footer__inner">
          <div className="site-footer__logos">
            <div className="site-footer__columns">
              <a href="https://www.fivb.org" target="_blank" title="Fédération Internationale de Volleyball">
                <img src="/images/logos/links_fivb.png" alt="FIVB" />
                <span className="responsive">Fédération Internationale de Volleyball</span>
              </a>

              <a href="https://www.volleyball-verband.de" target="_blank" title="Deutscher Volleyball Verband">
                <img src="/images/logos/links_dvv.png" alt="DVV" />
                <span className="responsive">Deutscher Volleyball Verband</span>
              </a>

              <a href="https://www.volleyball-bundesliga.de" target="_blank" title="Deutsche Volleyball Liga">
                <img src="/images/logos/links_dvl.png" alt="DVL" />
                <span className="responsive">Deutsche Volleyball Liga</span>
              </a>

              <a href="https://www.dvv-ligen.de/cms/home/dritte_liga_maenner/dritte_liga_ost/tabelle_spiele.xhtml" target="_blank" title="3. Bundesliga">
                <img src="/images/logos/links_dvv.png" alt="3. Bundesliga" />
                <span className="responsive">3. Bundesliga</span>
              </a>

              <a href="http://www.ssvb.org" target="_blank" title="Sächsischer Sportverband Volleyball">
                <img src="/images/logos/links_ssvb.png" alt="SSVB" />
                <span className="responsive">Sächsischer Sportverband Volleyball</span>
              </a>
            </div>
          </div>

          <nav className="site-footer__menu" aria-label="Footer Navigation">
	    <ul>
              <li id="siteaction-about">
                <a href="/impressum">Impressum</a>
              </li>

              <li id="siteaction-datenschutz">
                <a href="/datenschutz">Datenschutz</a>
              </li>

              <li id="siteaction-disclaimer">
                <a href="/disclaimer">Haftungsausschluss</a>
              </li>

            {/*
              <li id="siteaction-contact">
                <a href="/contact-form">Kontakt</a>
              </li>
            */}

              {!token && (
                <li id="siteaction-login">
                  <a href="/login">Login</a>
                </li>
              )}
            </ul>
          </nav>
        </div>
        <div className="copyright">
          <p>©
            <span>2026</span>
            Sportverein Reudnitz e.V.
            —
            powered by
            <a href="http://www.sertrec.de" target="blank" title="sertrec media">
              <img className="copyright-logo" src="/images/logos/logo_sertrec_invers.png" title="sertrec media" alt="sertrec media" />
            </a>
          </p>
        </div>
      </Container>
    </footer>
  )
};

export default connect((state) => ({
  token: state.userSession.token,
}))(Footer);